import { render, staticRenderFns } from "./searchBtodDone.vue?vue&type=template&id=06c70486"
import script from "./searchBtodDone.vue?vue&type=script&lang=js"
export * from "./searchBtodDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports